import styled from 'styled-components';

export default styled.div`
  position: relative;
  text-align: center;
  font-weight: 500;
  width: 300px;
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: 2rem;
`;
